/**
 * ACT004 进度条热点（type=19，与控制台 act004-progress-bar.js 口径一致）
 */

export function normalizeProgressBarPercent(raw, fallback = 0) {
  const n = parseFloat(raw)
  if (!Number.isFinite(n)) return fallback
  return Math.max(0, Math.min(100, n))
}

export function normalizeProgressBarSegment(seg) {
  if (!seg || typeof seg !== 'object') return null
  let start = normalizeProgressBarPercent(seg.startPercent, 0)
  let end = normalizeProgressBarPercent(seg.endPercent, start)
  if (end < start) {
    const t = start
    start = end
    end = t
  }
  if (end <= start) return null
  return {
    startPercent: start,
    endPercent: end,
    blockImage: String(seg.blockImage || '').trim()
  }
}

export function normalizeProgressBarSegments(source) {
  const arr = Array.isArray(source) ? source : []
  const out = []
  arr.forEach((raw) => {
    const s = normalizeProgressBarSegment(raw)
    if (!s) return
    out.push(s)
  })
  out.sort((a, b) => a.startPercent - b.startPercent)
  return out
}

export function normalizeProgressBarDurationMs(raw) {
  const n = parseInt(raw, 10)
  if (!Number.isFinite(n) || n < 0) return 3000
  return Math.min(120000, Math.max(0, n))
}

export function normalizeProgressBarDisplayOrder(raw) {
  const n = parseInt(raw, 10)
  return Number.isFinite(n) && n >= 0 ? n : 0
}

export function normalizeProgressBarCompleteTargetPageIndex(raw) {
  const n = parseInt(raw, 10)
  return Number.isFinite(n) && n >= 0 ? n : null
}

export function normalizeProgressBarFillTileSize(raw, fallback = 14) {
  const n = parseInt(raw, 10)
  if (!Number.isFinite(n) || n <= 0) return fallback
  return Math.min(200, Math.max(2, n))
}

export function normalizeProgressBarFillTileGap(raw, fallback = 5) {
  const n = parseInt(raw, 10)
  if (!Number.isFinite(n) || n < 0) return fallback
  return Math.min(80, Math.max(0, n))
}

export function normalizeProgressBarTrackInset(raw, fallback = 5) {
  const n = parseFloat(raw)
  if (!Number.isFinite(n)) return fallback
  return Math.max(0, Math.min(45, n))
}

export function pickProgressBarFields(source) {
  const s = source && typeof source === 'object' ? source : {}
  const segments = normalizeProgressBarSegments(s.progressBarSegments)
  const target = normalizeProgressBarCompleteTargetPageIndex(s.progressBarCompleteTargetPageIndex)
  return {
    progressBarBgImage: String(s.progressBarBgImage || '').trim(),
    progressBarFillImage: String(s.progressBarFillImage || '').trim(),
    progressBarSegments: segments,
    progressBarDurationMs: normalizeProgressBarDurationMs(s.progressBarDurationMs),
    progressBarCompleteTargetPageIndex: target,
    progressBarDisplayOrder: normalizeProgressBarDisplayOrder(s.progressBarDisplayOrder),
    progressBarFillTileWidth: normalizeProgressBarFillTileSize(s.progressBarFillTileWidth, 14),
    progressBarFillTileHeight: normalizeProgressBarFillTileSize(s.progressBarFillTileHeight, 32),
    progressBarFillTileGap: normalizeProgressBarFillTileGap(s.progressBarFillTileGap, 5),
    progressBarTrackInsetLeft: normalizeProgressBarTrackInset(s.progressBarTrackInsetLeft, 5),
    progressBarTrackInsetTop: normalizeProgressBarTrackInset(s.progressBarTrackInsetTop, 22),
    progressBarTrackInsetRight: normalizeProgressBarTrackInset(s.progressBarTrackInsetRight, 5),
    progressBarTrackInsetBottom: normalizeProgressBarTrackInset(s.progressBarTrackInsetBottom, 22)
  }
}
